// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_SalvarinfosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /usuarios/salvarInfos
 *
 * Returns success flag after saving user information.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_SalvarinfosResponseDados = boolean;

export type Usuarios_SalvarinfosResponse = ApiResponse<Usuarios_SalvarinfosResponseDados>;

registerResponseContract('Usuarios_SalvarinfosResponse', {})
